<template>
  <div class="disclaimer-tooltip" v-if="disclaimer" v-tooltip="disclaimer.value">
  </div>
</template>

<script>
export default {
  props: ['disclaimerKey'],
  computed: {
    disclaimer() {
      return this.$store.getters.disclaimerByGroupName(this.disclaimerKey)
    }
  }
}
</script>

<style lang="stylus">
.disclaimer-tooltip
  width 12px
  m-icon("info", 12)
  display inline-block

</style>
